import { useEffect } from 'react'
import { useAuth } from '@clerk/clerk-react'
import { api } from '../api/client'

/**
 * Hook that sets up the API client with Clerk authentication.
 * Call this once in your app (e.g., in App.tsx or a provider).
 */
export function useApiAuth() {
  const { getToken } = useAuth()

  useEffect(() => {
    // Set up the API client to use Clerk tokens
    api.setTokenGetter(async () => {
      try {
        return await getToken()
      } catch {
        return null
      }
    })
  }, [getToken])
}

/**
 * Re-export useAuth for convenience
 */
export { useAuth, useUser, useSession } from '@clerk/clerk-react'
